export default __webpack_public_path__ + "static/media/explorePin.fe07e8e8.svg";